// extracted by mini-css-extract-plugin
export var copyable = "_l-1";
export var explainable = "_l-0";
export var negative = "_l-2";
export var positive = "_l-3";